import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { AccountService, HttpCommonService } from "projects/sepidz-web-framework/src/lib/services";
import { take } from "rxjs/operators";

@Component({
  selector: "ngx-inv-daily-usage",
  templateUrl: "./inv-daily-usage.component.html",
  styleUrls: ["./inv-daily-usage.component.scss"],
})
export class InvDailyUsageComponent implements OnInit {
  formGroup: UntypedFormGroup;
  columns: form_control[] = [];
  itemLists: any;
  isMultiBranch: Boolean;

  constructor(
    fb: UntypedFormBuilder,
    private httpCommonService: HttpCommonService,
    private accountService: AccountService,
    private translate: TranslateService
  ) {
    const info = this.accountService.authService.currentInformation();
    this.isMultiBranch =
      (info.BranchingAdvancedEnabled || info.BranchingLightEnabled || info.RestaurantCallCenter) &&
      this.accountService.authService.currentBranch?.AccessToAllBranches;
    this.formGroup = fb.group({
      Goods: "",
      BranchId: "",
    });
  }

  ngOnInit() {
    this.setHeaderColumns();
  }
  setHeaderColumns() {
    this.columns.push(<form_control>{
      label: this.translate.instant("ClientApp.FrontOffice.Inv.DailyUsage.ProductCode"),
      controlType: FormControlTypes.textbox,
      modelName: "ItemCode",
      textType: "text",
      disabled: false,
      name: "ItemCode",
      order: 0,
      formVisible: false,
      listVisible: true,
      required: true,
    });
    this.columns.push(<form_control>{
      label: this.translate.instant("ClientApp.FrontOffice.Inv.DailyUsage.ItemTitle"),
      controlType: FormControlTypes.textbox,
      modelName: "ItemTitle",
      disabled: false,
      name: "ItemTitle",
      textType: "text",
      order: 1,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.columns.push(<form_control>{
      label: this.translate.instant("ClientApp.FrontOffice.Inv.DailyUsage.MeasurementUnit"),
      controlType: FormControlTypes.textbox,
      modelName: "UnitTitle",
      disabled: false,
      name: "UnitTitle",
      textType: "text",
      order: 2,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.columns.push(<form_control>{
      label: this.translate.instant("ClientApp.FrontOffice.Inv.DailyUsage.Amount"),
      controlType: FormControlTypes.textbox,
      modelName: "TotalAmount",
      disabled: false,
      name: "TotalAmount",
      textType: "text",
      order: 3,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.columns.push(<form_control>{
      label: this.translate.instant("ClientApp.FrontOffice.Inv.DailyUsage.ItemType"),
      controlType: FormControlTypes.textbox,
      modelName: "GoodsKindTitle",
      disabled: false,
      name: "GoodsKindTitle",
      textType: "text",
      order: 3,
      formVisible: true,
      listVisible: true,
      required: false,
    });
  }

  getData() {
    const branchId = this.formGroup.controls["BranchId"].value !== "" ? this.formGroup.controls["BranchId"].value : null;
    const goodsId = this.formGroup.controls["Goods"].value;
    this.httpCommonService
      .get(`MaterialUseInProduct/GetGoodsUsage/${goodsId}/${branchId}`)
      .pipe(take(1))
      .subscribe({
        next: (res) => {
          this.itemLists = res;
        },
      });
  }
}
